import { Component, Input } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { TooltipModule } from 'primeng/tooltip'

@Component({
  selector: 'truncated-copy',
  standalone: true,
  imports: [ButtonModule, TooltipModule],
  template: `<span class="value" [pTooltip]="text">{{ text }}</span><p-button icon="pi pi-copy" [text]="true" size="small" aria-label="Copy value" pTooltip="Copy value" (onClick)="copy()" />`,
  styles: `:host{display:flex;align-items:center;min-width:0;gap:.15rem}.value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;flex:1}:host ::ng-deep .p-button{width:1.45rem;height:1.45rem;flex:0 0 auto;padding:0}`,
})
export class TruncatedCopyComponent {
  @Input({ required: true }) text = ''

  async copy(): Promise<void> {
    await navigator.clipboard?.writeText(this.text)
  }
}
